class HeroSlider {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('.hero-slider__track');
    this.slides = Array.from(el.querySelectorAll('.hero-slider__slide'));
    this.dots = Array.from(el.querySelectorAll('.hero-slider__dot'));
    this.prevBtn = el.querySelector('.hero-slider__arrow--prev');
    this.nextBtn = el.querySelector('.hero-slider__arrow--next');

    this.current = 0;
    this.autoplay = el.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(el.dataset.autoplaySpeed, 10) || 5000;
    this.timer = null;

    if (this.slides.length <= 1) return;

    this.bindEvents();
    this.startAutoplay();
  }

  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.go(this.current - 1);
        this.restartAutoplay();
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.go(this.current + 1);
        this.restartAutoplay();
      });
    }
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.go(parseInt(dot.dataset.slideIndex, 10));
        this.restartAutoplay();
      });
    });

    // Pause on hover / focus for accessibility
    this.el.addEventListener('mouseenter', () => this.stopAutoplay());
    this.el.addEventListener('mouseleave', () => this.startAutoplay());
    this.el.addEventListener('focusin', () => this.stopAutoplay());
    this.el.addEventListener('focusout', () => this.startAutoplay());

    // Pause when tab not visible
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.stopAutoplay();
      } else {
        this.startAutoplay();
      }
    });

    // Basic swipe support
    let startX = 0;
    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });
    this.track.addEventListener('touchend', (e) => {
      const diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) > 40) {
        this.go(diff > 0 ? this.current - 1 : this.current + 1);
        this.restartAutoplay();
      }
    }, { passive: true });
  }

  go(index) {
    const total = this.slides.length;
    const next = (index + total) % total;

    this.slides[this.current].classList.remove('is-active');
    this.slides[this.current].setAttribute('aria-hidden', 'true');
    const currentLink = this.slides[this.current].querySelector('.hero-slider__button');
    if (currentLink) currentLink.setAttribute('tabindex', '-1');

    this.slides[next].classList.add('is-active');
    this.slides[next].removeAttribute('aria-hidden');
    const nextLink = this.slides[next].querySelector('.hero-slider__button');
    if (nextLink) nextLink.removeAttribute('tabindex');

    if (this.dots.length) {
      this.dots[this.current].classList.remove('is-active');
      this.dots[this.current].setAttribute('aria-selected', 'false');
      this.dots[next].classList.add('is-active');
      this.dots[next].setAttribute('aria-selected', 'true');
    }

    this.current = next;
  }

  startAutoplay() {
    if (!this.autoplay || this.timer) return;
    this.timer = setInterval(() => this.go(this.current + 1), this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }
}

function initHeroSliders() {
  document.querySelectorAll('.hero-slider').forEach((el) => {
    if (!el.dataset.initialized) {
      el.dataset.initialized = 'true';
      new HeroSlider(el);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeroSliders);
} else {
  initHeroSliders();
}

// Re-init when section is added/re-rendered in the theme editor
document.addEventListener('shopify:section:load', (e) => {
  const el = e.target.querySelector('.hero-slider');
  if (el) {
    el.dataset.initialized = '';
    new HeroSlider(el);
  }
});
